<template>
  <div>
    <v-autocomplete
      ref="select"
      :items="availableClientSpecialists"
      v-model="proxyValue"
      item-text="name"
      item-value="id"
      no-data-text="No specialists"
      label="Please, select specialist"
      multiple
      small-chips
      deletable-chips
      clearable
      @keyup.enter="handleEnterKeyup"
    >
      <template
        slot="selection"
        slot-scope="props"
      >
        <v-chip
          close
          class="chip--select-multi v-chip--small"
          @input="removeItem(props.item)"
        >
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.item.initials }}
            </span>
            {{ props.item.name }}
          </v-tooltip>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'

    export default {
        name: 'client-specialists-select',
        props: {
            value: {
                type: Array,
            }
        },
        data() {
            return {}
        },
        mounted() {
            this.fetchInitDataIfRequired()
        },
        computed: {
            ...mapState({
                availableClients: 'availableClients'
            }),
            proxyValue: {
                get() {
                    return this.value
                },
                set(newValue) {
                    this.$emit('input', newValue)
                }
            },
            availableClientSpecialists() {
                const clientsById = _.keyBy(this.availableClients, 'id');

                let parenthesesContentRegexp = /\([^)]*\)/g;

                let result = [];
                for (let clientId in clientsById) {
                    const client = _.get(clientsById, clientId, {});
                    const specialists = _.get(client, 'specialists', {});

                    let shortClientTitle = _.truncate(_.get(client, 'title', ''), {
                        length: 8
                    });

                    for (let specialist of specialists) {
                        let words = _.words(_.trim(_.replace(specialist.name, parenthesesContentRegexp, '')));

                        let initials = '';
                        for (let word of words) {
                            initials += _.toUpper(word[0])
                        }

                        result.push({
                            id: specialist.id,
                            name: `${specialist.name} (${client.title})`,
                            initials: `${initials} (${shortClientTitle})`
                        })
                    }
                }

                return result;
            }
        },
        methods: {
            ...mapActions({
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
            removeItem(removedItem) {
                const removeIndex = this.value.indexOf(removedItem.id);
                let newValue = _.filter(this.value, (item, index) => index !== removeIndex);
                this.$emit('input', newValue)
            },
            handleEnterKeyup() {
                let filteredItems = this.$refs.select.computedItems.map(it => it.id);
                const newValue = _.union(this.value, filteredItems);
                this.$emit('input', newValue)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ClientSpecialistSelect.vue